// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__eMQUE","title":"FrontImage_title__19Ees"};